import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import {
  DELETE_TEMPLATE_REDUCER_NAME,
  TEMPLATES_LIST_REDUCER_NAME,
} from 'features/templates/consts'
import { fetchDomain } from 'features/domains/api'
import { deleteTemplate } from 'features/templates/api'

const templatesListSlice = makeFetchSlice(TEMPLATES_LIST_REDUCER_NAME)
export const templatesListReducer = templatesListSlice.reducer
export const templatesListActions = templatesListSlice.actions

export const fetchTemplatesListThunk = (domainId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: templatesListActions,
        asyncFunc: () => fetchDomain(domainId, { configs: true }),
      })
    } catch (error) {
      console.log('Error fetching templates', error)
    }
  }
}

const deleteTemplateSlice = makeFetchSlice(DELETE_TEMPLATE_REDUCER_NAME)
export const deleteTemplateReducer = deleteTemplateSlice.reducer
export const deleteTemplateActions = deleteTemplateSlice.actions

export const deleteTemplateThunk = (rootDomainId: string, id: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: deleteTemplateActions,
        asyncFunc: () => deleteTemplate(id),
      })

      dispatch(fetchTemplatesListThunk(rootDomainId))
    } catch (error) {
      console.log(`Error deleting Template with id: ${id}`, error)
    }
  }
}
